import { useEffect, useState } from "react";

import fetchTagsByRoute from "app/umbraco/helpers/fetchTagsByRoute";

export default (url: string): any => {
    const [items, setItems] = useState<any[]>();
    const [viewState, setViewState] = useState<string>("LOADING");

    useEffect(() => {
        let isComponentMounted = true;

        const fetchFilters = async () => {
            let result: any[] = [];

            const response = await fetchTagsByRoute(url);

            if (response && response.length > 0) {
                result = response;
            }

            return result;
        };

        fetchFilters().then((result: any) => {
            if (isComponentMounted) {
                if (result && result.length > 0) {
                    setItems(result);
                    setViewState("LOADED");
                }
                else {
                    setViewState("EMPTY");
                }
            }
        }).catch(() => {
            setViewState("ERROR");
        });

        return () => {
            isComponentMounted = false;
        };
    }, []);

    return [items, viewState];
};